<div class="w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0 mt-8">
    <form [formGroup]="pageForm" (ngSubmit)="createArticle()">
        <div class="rounded-t bg-white">
            <div class="rounded-t bg-white mb-0 px-6 py-4">
                <span class="text-blueGray-700 text-lg font-bold">New Article</span>
            </div>
        </div>
        <mat-stepper orientation="vertical" linear="false" #stepper>
            <mat-step [completed]="pageForm.get('articleText')?.value != ''" class="bg-blueGray-100">
                <ng-template matStepLabel>Write Article</ng-template>
                <div class="grid grid-rows-1 gap-4 justify-center p4 my-4 h-400-px w-full">
                    <div class="my-1 w-full flex flex-wrap justify-end gap-2">
                        <!-- <button (click)="fileUpload.click()"
                            class="bg-secondary-500 active:bg-primary-500 hover:bg-primary-300 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                            type="button"><i class="fa fa-download mr-2 leading-relaxed"></i>Import File
                        </button> -->
                        <!-- <button (click)="saveArticle()"
                            class="bg-secondary-500 active:bg-primary-500 hover:bg-primary-300 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                            type="button"><i class="fa fa-upload mr-2 leading-relaxed"></i>Save File
                        </button> -->
                    </div>
                    <!-- <input type="file" #fileUpload [accept]="'.txt'" (change)="loadArticle($event)" class="hidden"> -->
                    <!-- <app-text-editor #textEditor class="display:block container w-full"></app-text-editor> -->
                </div>
            </mat-step>
            <mat-step [stepControl]="pageForm" label="Article Details">
                <div class="pt-4">
                    <div class="mb-1 w-full">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Title *
                        </label>
                        <input type="text" type="title" formControlName="title" id="title" name="title" required
                            class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-1.5 px-3 ease-linear transition-all duration-150"
                            rows="4" />
                        <div
                            class="{{pageForm.get('title')?.invalid && (pageForm.get('title')?.dirty || pageForm.get('title')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                            <div *ngIf="pageForm.get('title')?.errors?.['required']">
                                Value is required
                            </div>
                            <div
                                *ngIf="pageForm.get('title')?.errors?.['minlength'] || pageForm.get('title')?.errors?.['maxlength']">
                                Min 10 and max 200 characters required
                            </div>
                        </div>
                    </div>
                    <div class="mb-1 w-full">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mt-4 mb-1">
                            Description *
                        </label>
                        <textarea type="text" type="description" formControlName="description" id="description"
                            name="description" required
                            class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            rows="4">
                        </textarea>
                        <div
                            class="{{pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched)? 'visible' : 'invisible' }} h-6 text-red-500 text-xs">
                            <div *ngIf="pageForm.get('description')?.errors?.['required']">
                                Value is required
                            </div>
                            <div
                                *ngIf="pageForm.get('description')?.errors?.['minlength'] || pageForm.get('description')?.errors?.['maxlength']">
                                Min 10 and max 500 characters required
                            </div>
                        </div>
                    </div>
                    <div class="mb-1 w-full">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Tags
                        </label>
                        <div class="flex flex-wrap gap-1">
                            <button (click)="removeTag(i)" type="button" *ngFor="let item of tags; index as i"
                                data-dismissible="chip"
                                class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 my-1 text-xs font-bold text-white">
                                <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                            </button>
                        </div>
                        <div class="flex flex-row align-middle mt-1">
                            <input formControlName="tagField" id="tagField" name="tagField" type="text"
                                class="border-0 grow placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                            <button (click)="addTag()" type="button"
                                class="bg-primary-500 basis-1/4 whitespace-nowrap rounded ml-4 text-xs text-white px-2">Add
                                Tag</button>
                        </div>
                        <div
                            class="{{pageForm.get('tagField')?.invalid && (pageForm.get('tagField')?.dirty || pageForm.get('tagField')?.touched)? 'visible' : 'invisible' }} pt-1 h-4 text-red-500 text-xs">
                            @if(pageForm.get('tagField')?.errors?.['invalidValue']) {
                            <p>No blanks or spaces allowed</p>
                            } @else if(pageForm.get('tagField')?.errors?.['maxValuesAllowed']) {
                            <p>Only 10 values allowed</p>
                            }
                        </div>
                    </div>
                    <div>
                        <div class="w-full mb-1">
                            <button type="submit" [disabled]="!pageForm.valid || working"
                                class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 mt-4 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                                mat-button>
                                <div *ngIf="!working" class="inline-block">
                                    <i class="fa fa-save mr-2 leading-relaxed"></i>Create
                                </div>
                                <div *ngIf="working" class="inline-block">
                                    <app-loading-dots></app-loading-dots>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-stepper>
    </form>
</div>